import { Pages } from "@constants/pages/Pages";
import { TabService } from "@services/tabs/TabService";
import { IHasGuid } from "@app/shared/interfaces/IHasGuid";
import { ItemLinkableBase } from "@app/shared/linkable/item-linkable-base";
import { Observable } from "rxjs";
import { Component, Input, inject } from "@angular/core";
import { KriDataService } from "../services/kri-data.service";
import { RendererConfig } from "@models/workspace/RendererConfig";
import { LinkableComponent } from "@app/shared/linkable/linkable.component";

@Component({
    selector: "kri-linkable",
    templateUrl: "./kri-linkable.component.html",
    styleUrls: ["./kri-linkable.component.scss"],
    imports: [LinkableComponent]
})
export class KriLinkableComponent extends ItemLinkableBase {
    @Input() typename = "kri";

    hasAccessChecks = {};
    accessCheckInProgress = false;

    private _kriDS = inject(KriDataService);
    private _pages = inject(Pages);
    private _tabService = inject(TabService);

    rendererConfig: RendererConfig[] = [
        RendererConfig.createScoreConfig("Aggregate score", "Aggregate score color"),
    ];

    hasAccessToItem(guid: string): Observable<boolean> {
        return this._kriDS.hasAccess(guid);
    }

    openTab(item: IHasGuid, hasAccess: boolean) {
        if (hasAccess === true) {
            this._tabService.generateTab(
                this._pages.KriDetail,
                item.guid,
                `(KRI) ${item[this.displayValueProp]}`
            );
        } else {
            this._toastr.warning("Not enough rights to open this KRI.");
        }
    }
}
